import type { UseInfiniteQueryOptions } from "react-query";
import { useInfiniteQuery } from "react-query";
import type { ApiError } from "@circle-react/config/CustomErrors";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";

export const useInfiniteQueryWrapper = (
  path: string,
  queryOptions: UseInfiniteQueryOptions<any, ApiError, any, any> = {},
  key: any,
) => {
  const queryKey = Array.isArray(key) ? key : [key || path];

  const fetchPage = (page: number) =>
    reactQueryGet(appendParamsToPath(path, { page }));

  const infiniteQuery = useInfiniteQuery<any, ApiError, any, any>(
    queryKey,
    ({ pageParam = 1 }) => fetchPage(pageParam),
    {
      getNextPageParam: lastPage =>
        lastPage.has_next_page ? lastPage.page + 1 : undefined,
      ...queryOptions,
    },
  );

  const mapPages = (callback: (page: any) => any) => {
    const { isLoading, data } = infiniteQuery;
    if (isLoading || !data) return [];
    return data.pages.map(callback);
  };

  return {
    ...infiniteQuery,
    mapPages,
  };
};

const appendParamsToPath = (
  path: string,
  params: Record<string, string | number>,
) => {
  // Need to add origin to the relative path to be a fully
  // qualified argument the URL class
  const url = new URL(window.location.origin + path);
  for (const [key, value] of Object.entries(params)) {
    url.searchParams.set(key, String(value));
  }
  return url.pathname + url.search;
};
